import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {
    Badge,
    Card,
    CardActionArea,
    Collapse,
    Fade,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { ExpandLessRounded, ExpandMoreRounded, LocalOffer } from '@mui/icons-material';
import { Box, Stack } from '@mui/system';
import { IconBarcode, IconBox, IconBoxModel2, IconNfc, IconTruckDelivery } from '@tabler/icons-react';

const InventoryTagInfo = (props) => {
    const theme = useTheme();

    const [item, setItem] = useState(null);

    useEffect(() => {
        setItem(props.item);
    }, [props.item]);

    const handleCardClick = () => {
        props.onClick();
    };

    if (!item) {
        return false;
    }

    return (
        <Card variant={'outlined'} key={item?.id} sx={{ height: '100%' }}>
            <CardActionArea onClick={handleCardClick}>
                <Stack direction="row" spacing={2} sx={{ height: '100%' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#72c5cb', //'#72c5cb'
                            color: '#fff',
                            padding: '0.5rem'
                        }}
                    >
                        <IconBox color={'#fff'} size={34} />
                    </Box>
                    <Box sx={{ padding: '0.5rem' }}>
                        <List disablePadding>
                            <ListItem disablePadding key={item?.id + '-barcode'}>
                                <ListItemIcon>
                                    <IconBarcode/>
                                </ListItemIcon>
                                <ListItemText primary={item?.product?.Código_barras_de_la_etiqueta} secondary={'Código de barras'} />
                            </ListItem>
                            <ListItem disablePadding key={item?.id + '-proveedor'}>
                                <ListItemIcon>
                                    <IconBoxModel2/>
                                </ListItemIcon>
                                <ListItemText primary={item?.product?.Nombre_proveedor} secondary={'Proveedor'} />
                            </ListItem>
                            <ListItem disablePadding key={item?.id + '-destination'}>
                                <ListItemIcon>
                                    <IconTruckDelivery/>
                                </ListItemIcon>
                                <ListItemText primary={item?.product?.Centro_destino || ' --- '} secondary={'Destino'} />
                            </ListItem>
                        </List>
                    </Box>
                </Stack>
            </CardActionArea>
        </Card>
    );
};

InventoryTagInfo.propTypes = {
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func
};

InventoryTagInfo.defaultProps = {
    onClick: () => {}
};

export default InventoryTagInfo;
